import { render, staticRenderFns } from "./pin-login-keyboard.vue?vue&type=template&id=c2f1b286&scoped=true&"
import script from "./pin-login-keyboard.vue?vue&type=script&lang=js&"
export * from "./pin-login-keyboard.vue?vue&type=script&lang=js&"
import style0 from "./pin-login-keyboard.vue?vue&type=style&index=0&id=c2f1b286&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f1b286",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VHover,VIcon,VTextField})
